import { useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form';
import useModal from '../../../hooks/useModal';
import Input from '../../../components/form-controls/Input';
import Button from '../../../components/form-controls/Button';
import { useCurrentAccount } from '../../../hooks/useCurrentAccount';
import { FollowConfigService } from '../../../services/FollowConfigService';
import { AlertService } from '../../../services/Alert';
import { BlacklistWordsConfigService } from '../../../services/BlacklistWordsConfigService';

interface AddWordModalProps {
    show: boolean
    onRequestClose: (refresh: boolean) => void;
    payload: any
}

export default function AddWordModal({ show, onRequestClose, payload }: AddWordModalProps) {
    const modalRef = useRef<HTMLDivElement>(null)

    useModal(modalRef, show)

    const defaultValues = {
        id: '',
        word: '',
    }
    const { register, handleSubmit, reset, watch, formState: { errors, isValid, isSubmitting } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const { account } = useCurrentAccount();

    const closeAndReset = async (reload: boolean) => {
        await onRequestClose(reload);
        reset(defaultValues);
    }


    useEffect(() => {
        reset({
            id: payload?.id || '',
            word: payload?.word || ''
        })
    }, [payload])

    const submit = async (data) => {
        try {
            payload != null ? await BlacklistWordsConfigService.editWord(data.id, data.word) : await BlacklistWordsConfigService.addWord(account.id, data.word);
            await onRequestClose(true);
            reset(defaultValues);
            AlertService.toastSuccess('Se ha guardado correctamente la palabra')
        } catch (error) {
            console.log(error)
            AlertService.error('Error', 'No se pudo guardar la palabra, intenta nuevamente.')
        }
    }

    return (
        <div className='modal fade' ref={modalRef} data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog " role="document">
                <form onSubmit={handleSubmit(submit)}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" >{watch('id') ? 'Editar' : 'Agregar'} palabra</h4>
                            <button type="button" className="btn-close" onClick={() => closeAndReset(false)}></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <Input label={'Palabra *'} errors={errors.word} {...register('word', { required: true })} />
                            </div>
                            
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-white btn-sm" onClick={() => closeAndReset(false)}>Cancelar</button>
                            <Button type="submit" className="btn btn-primary btn-sm" onClick={handleSubmit(submit)} disabled={!isValid} isLoading={isSubmitting}>{watch('id') ? 'Editar' : 'Guardar'}</Button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}
